import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getApiUrlString } from 'src/app/shared/utility/webFactory';

@Injectable({
  providedIn: 'root',
})
export class MenuConfigurationService {
  constructor(private readonly http: HttpClient) {}

  getAppConfiguration(): Observable<unknown> {
    return this.http.get(`${getApiUrlString('getAppConfiguration')}`);
  }
}
